import type { ReactNode } from "react";

interface SectionHeaderProps {
  eyebrow: string;
  eyebrowTone?: "primary" | "accent" | "secondary";
  title: ReactNode;
  subtitle?: string;
  align?: "left" | "center";
  action?: ReactNode;
}

export default function SectionHeader({
  eyebrow,
  eyebrowTone = "primary",
  title,
  subtitle,
  align = "left",
  action,
}: SectionHeaderProps) {
  const toneMap: Record<string, string> = {
    primary: "bg-primary-100 text-primary-700",
    accent: "bg-accent-100 text-accent-700",
    secondary: "bg-secondary-100 text-secondary-800",
  };
  return (
    <div
      className={`mb-8 md:mb-12 flex flex-col gap-4 sm:flex-row sm:items-end ${
        align === "center" ? "sm:flex-col sm:items-center text-center" : "sm:justify-between"
      }`}
    >
      <div className={align === "center" ? "flex flex-col items-center" : ""}>
        <span
          className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium ${toneMap[eyebrowTone]}`}
        >
          {eyebrow}
        </span>
        <h2 className="mt-4 text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
          {title}
        </h2>
        {subtitle && (
          <p
            className={`mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${
              align === "center" ? "mx-auto" : ""
            }`}
          >
            {subtitle}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}